import { HStack, Heading, type HeadingProps } from '@chakra-ui/react'
import * as React from 'react'

/**
 * CardHeading — Icon + Heading row for card section titles.
 *
 * Replaces the repeated pattern:
 *   <HStack gap={2}>
 *     <Icon as={LuWallet} />
 *     <Heading size={{ base: 'sm', md: 'md' }}>Title</Heading>
 *   </HStack>
 */

export interface CardHeadingProps extends Omit<HeadingProps, 'size'> {
    icon?: React.ReactElement
    size?: HeadingProps['size']
}

export const CardHeading = React.forwardRef<HTMLHeadingElement, CardHeadingProps>(
    function CardHeading({ icon, children, size = { base: 'sm', md: 'md' }, ...rest }, ref) {
        if (!icon) {
            return (
                <Heading ref={ref} size={size} {...rest}>
                    {children}
                </Heading>
            )
        }

        return (
            <HStack gap={2}>
                {icon}
                <Heading ref={ref} size={size} {...rest}>
                    {children}
                </Heading>
            </HStack>
        )
    }
)
